import styled from 'styled-components';

export const SContainer = styled.div`
  margin: 0 ${({ theme }) => -theme.spacing.md}rem;
`;
